"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorFamily = exports.ColorAliases = exports.Colors = void 0;
var Colors;
exports.Colors = Colors;

(function (Colors) {
  Colors["APRICOT_10"] = "#FCF0ED";
  Colors["APRICOT_30"] = "#F4C1B1";
  Colors["APRICOT_50"] = "#ED9D85";
  Colors["APRICOT_60"] = "#E98567";
  Colors["EBONY_60"] = "#4B5E63";
  Colors["EBONY_70"] = "#3C4C50";
  Colors["EBONY_80"] = "#2E393C";
  Colors["EBONY_90"] = "#1F2729";
  Colors["GREEN_10"] = "#DAF4E6";
  Colors["GREEN_20"] = "#C2E9D4";
  Colors["GREEN_30"] = "#36BC73";
  Colors["GREEN_50"] = "#278753";
  Colors["GREEN_60"] = "#237A4B";
  Colors["GREY_05"] = "#FAFAFA";
  Colors["GREY_10"] = "#EEEEEE";
  Colors["GREY_30"] = "#BBB9B3";
  Colors["GREY_30_A30"] = "#BBB9B34D";
  Colors["GREY_50"] = "#9B988F";
  Colors["GREY_50_A30"] = "#9B988F4D";
  Colors["GREY_60"] = "#85837F";
  Colors["GREY_70"] = "#757269";
  Colors["GREY_80"] = "#555555";
  Colors["IVORY_05"] = "#FCFAF2";
  Colors["IVORY_10"] = "#F7F3E7";
  Colors["IVORY_20"] = "#EFE9D7";
  Colors["IVORY_30"] = "#E8DFCA";
  Colors["MARINE_10"] = "#D2F0F4";
  Colors["MARINE_20"] = "#AFEEF6";
  Colors["MARINE_30"] = "#81D4DF";
  Colors["MARINE_50"] = "#32B2C4";
  Colors["MARINE_60"] = "#2C9EAC";
  Colors["PEACH_10"] = "#FCEDE3";
  Colors["PEACH_20"] = "#FFE8D9";
  Colors["PEACH_30"] = "#FBE0CE";
  Colors["PEACH_50"] = "#F6B98F";
  Colors["PEACH_60"] = "#F3A570";
  Colors["RED_10"] = "#FDECEB";
  Colors["RED_20"] = "#FFCCCA";
  Colors["RED_30"] = "#F6928D";
  Colors["RED_50"] = "#F1564E";
  Colors["RED_60"] = "#EF382F";
  Colors["SAGE_10"] = "#E9F3ED";
  Colors["SAGE_20"] = "#CFE0D8";
  Colors["SAGE_30"] = "#85A495";
  Colors["SAGE_40"] = "#628373";
  Colors["SAGE_50"] = "#455C51";
  Colors["SAGE_60"] = "#364940";
  Colors["WHITE"] = "#FFFFFF";
  Colors["WHITE_A40"] = "#FFFFFF66";
  Colors["YELLOW_10"] = "#FEF0D9";
  Colors["YELLOW_20"] = "#FFE0AC";
  Colors["YELLOW_30"] = "#FDD086";
  Colors["YELLOW_50"] = "#FCB643";
  Colors["YELLOW_60"] = "#FBA922";
})(Colors || (exports.Colors = Colors = {}));

var ColorAliases;
exports.ColorAliases = ColorAliases;

(function (ColorAliases) {
  ColorAliases["DANGER"] = "#F1564E";
  ColorAliases["DEFAULT"] = "#9B988F";
  ColorAliases["SUCCESS"] = "#278753";
  ColorAliases["WARNING"] = "#FCB643";
  ColorAliases["PRIMARY"] = "#32B2C4";
})(ColorAliases || (exports.ColorAliases = ColorAliases = {}));

var ColorFamily = {
  APRICOT: 'apricot',
  GREEN: 'green',
  IVORY: 'ivory',
  MARINE: 'marine',
  PEACH: 'peach',
  RED: 'red',
  SAGE: 'sage',
  YELLOW: 'yellow'
};
exports.ColorFamily = ColorFamily;